import {ethers, formatUnits} from 'ethers';
import { RoundInfo } from '../model/round.model';
import { formatUsdcToTokenPrice } from '../utils/web3-convert.utils';

// Mapper for RoundInfo
export const mapRoundInfo = (data: any): RoundInfo => {
    return {

        roundId: data.roundId,
        roundDetails: {
            roundStatus: data.roundDetails.roundStatus,
            roundType: data.roundDetails.roundType,
            allocation: Number(formatUnits(data.roundDetails.allocation, 18)),
            isStakable: data.roundDetails.isStakable,
            tokenPrice: formatTokenPrice(data.roundDetails.tokenPrice)
        }
    };
}; 

// TODO: remove
const formatTokenPrice = (price: any): number => {
    try {
        const formattedPrice = ethers.formatUnits(price.toString(), 5);
        return Number(formattedPrice)
    } catch (error) {
        console.error("Error formatting token price:", error);
        return -1;
    }
}
